export default function PPTSkeletonLoader() {
    return (
      <div className="flex-1 py-4 !px-[30px] justify-center sm:px-[50px] md:px-[20px] lg:px-[100px] xl:!px-[220px] 2xl:!px-[220px] overflow-y-auto flex flex-col">
        <div className="space-y-8">
          {/* Skeleton for user message */}
          <div className="flex justify-end mt-12 mb-8">
            <div className="flex flex-row gap-2">
              <div className="flex flex-col">
                <div className=" bg-gray-200 rounded-bl-[16px] rounded-br-[16px] rounded-tl-[16px] p-[14px] min-h-[44px] w-fit animate-pulse">
                  <div className="h-4 bg-gray-300 rounded w-48"></div>
                </div>
              </div>
              <div className="w-[30px]">
                <div className="w-[40px] h-[40px] rounded-full bg-gray-200 animate-pulse"></div>
              </div>
            </div>
          </div>
  
          {/* Skeleton for bot message */}
          <div className="mt-8 mb-8 max-w-4xl mx-auto">
            <div className="flex gap-4 w-[280px] sm:w-full">
              <div className="w-[40px]">
                <div className="w-[40px] h-[40px] rounded-full bg-gray-200 animate-pulse"></div>
              </div>
              <div className="flex-1 space-y-2">
                <div className="h-4 bg-gray-200 rounded w-3/4 animate-pulse"></div>
                <div className="h-4 bg-gray-200 rounded w-full animate-pulse"></div>
                <div className="h-4 bg-gray-200 rounded w-5/6 animate-pulse"></div>
              </div>
            </div>
          </div>
  
          {/* Skeleton for user message */}
          <div className="flex justify-end mt-12 mb-8">
            <div className="flex flex-row gap-2">
              <div className="flex flex-col">
                <div className="w-full bg-gray-200 rounded-bl-[16px] rounded-br-[16px] rounded-tl-[16px] p-[14px] min-h-[44px] w-fit animate-pulse">
                  <div className="h-4 bg-gray-300 rounded w-48"></div>
                </div>
              </div>
              <div className="w-[30px]">
                <div className="w-[40px] h-[40px] rounded-full bg-gray-200 animate-pulse"></div>
              </div>
            </div>
          </div>
  
          {/* Skeleton for bot message */}
          <div className="mt-8 mb-8 max-w-4xl mx-auto">
            <div className="flex gap-4 w-[280px] sm:w-full">
              <div className="w-[40px]">
                <div className="w-[40px] h-[40px] rounded-full bg-gray-200 animate-pulse"></div>
              </div>
              <div className="flex-1 space-y-2">
                <div className="h-4 bg-gray-200 rounded w-3/4 animate-pulse"></div>
                <div className="h-4 bg-gray-200 rounded w-full animate-pulse"></div>
                <div className="h-4 bg-gray-200 rounded w-5/6 animate-pulse"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  